import { useEffect, useRef } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Global subscribers to data-change events (real-time sync).
// Any component can subscribe with `useDataSync("fees", callback)` and the
// callback fires whenever the backend broadcasts a "fees" entity change.
const subscribers = new Map(); // entity -> Set<callback>
let ws = null;
let ready = false;
let retry = null;

function connect() {
  const token = localStorage.getItem("ym_access_token");
  if (!token) return;
  try {
    const url = new URL(BACKEND_URL);
    const proto = url.protocol === "https:" ? "wss:" : "ws:";
    ws = new WebSocket(`${proto}//${url.host}/api/ws/chat?token=${encodeURIComponent(token)}`);
    ws.onmessage = (ev) => {
      try {
        const msg = JSON.parse(ev.data);
        if (msg?.type === "data:changed") {
          const set = subscribers.get(msg.entity);
          if (set) set.forEach((cb) => { try { cb(msg); } catch { /* ignore */ } });
          const allSet = subscribers.get("*");
          if (allSet) allSet.forEach((cb) => { try { cb(msg); } catch { /* ignore */ } });
        }
      } catch { /* ignore */ }
    };
    ws.onopen = () => { ready = true; };
    ws.onclose = () => {
      ready = false;
      if (retry) clearTimeout(retry);
      retry = setTimeout(connect, 3000);
    };
    ws.onerror = () => { try { ws.close(); } catch { /* ignore */ } };
  } catch { /* ignore */ }
}

export function ensureDataSocket() {
  if (!ws || ws.readyState > 1) connect();
}

export function useDataSync(entities, callback) {
  const cbRef = useRef(callback);
  useEffect(() => { cbRef.current = callback; }, [callback]);
  useEffect(() => {
    ensureDataSocket();
    const list = Array.isArray(entities) ? entities : [entities];
    const handler = (msg) => cbRef.current?.(msg);
    list.forEach((e) => {
      if (!subscribers.has(e)) subscribers.set(e, new Set());
      subscribers.get(e).add(handler);
    });
    return () => {
      list.forEach((e) => subscribers.get(e)?.delete(handler));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Array.isArray(entities) ? entities.join("|") : entities]);
}
